var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo182(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 189,
    viewBox: "0 0 174 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.831 167.762C133.902 167.619 142.709 162.513 142.709 162.513C141.662 161.615 140.554 160.789 139.394 160.042L138.383 162.328L138.263 159.371C137.65 159.026 137.009 158.736 136.348 158.504L134.793 162.022L134.638 158.198C134.617 158.199 134.595 158.199 134.574 158.2C131.504 158.343 128.177 160.601 127.143 163.241C126.11 165.882 127.761 167.906 130.831 167.762Z",
    fill: "#8DDAE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8957 182.214C81.0542 182.015 90.4131 177.435 90.4131 177.435C89.3792 176.684 88.2932 176.006 87.1686 175.41L85.9872 177.386L86.0517 174.864C85.4275 174.58 84.7878 174.348 84.1424 174.173L82.3242 177.215L82.4076 173.955C82.3857 173.956 82.3636 173.956 82.3418 173.958C79.1833 174.157 75.6275 176.168 74.3997 178.448C73.1719 180.728 74.7371 182.414 77.8957 182.214Z",
    fill: "#8DDAE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.013 45.1722L164.364 68.9472L92.8432 33.4657L83.5472 12.0942L154.013 45.1722Z",
    fill: "url(#paint0_linear_702_70636)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.929 135.563C77.1499 135.72 77.2481 136.01 77.1506 136.263C77.1061 136.377 72.6649 147.852 68.2187 155.482C63.1261 164.218 53.6682 167.207 45.2153 162.752C41.7766 160.939 39.6903 158.754 38.8419 156.072C37.1598 150.765 40.7478 144.363 44.5464 137.587L45.498 135.883C51.4055 125.255 54.2338 122.878 54.3513 122.781C54.5913 122.586 54.9532 122.631 55.1611 122.882C55.3676 123.135 55.3407 123.498 55.1009 123.694C55.0759 123.716 52.2721 126.116 46.507 136.486L45.5519 138.192C41.8773 144.751 38.4042 150.946 39.933 155.771C40.6808 158.128 42.5685 160.08 45.7071 161.733C53.5936 165.89 62.4392 163.063 67.221 154.86C71.6248 147.304 76.0343 135.913 76.0775 135.798C76.1903 135.506 76.5226 135.372 76.8178 135.5L76.929 135.563",
    fill: "url(#paint1_linear_702_70636)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2405 144.461L99.3297 157.881L25.8842 115.759L24.3461 111.673L19.3566 105.821L24.3461 111.673L25.7961 109.542L86.2405 144.461Z",
    fill: "url(#paint2_linear_702_70636)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.686 44.3063L163.855 67.6067L98.8858 157.071L90.1039 150.874L86.0596 143.914L153.686 44.3063Z",
    fill: "url(#paint3_linear_702_70636)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.503 68.899L151.954 65.3281L154.184 45.2396L164.503 68.899Z",
    fill: "url(#paint4_linear_702_70636)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.99 65.1206L90.6415 151.782L99.423 157.969L164.424 68.6016L151.99 65.1206",
    fill: "url(#paint5_linear_702_70636)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8.75543,
    height: 3.85945,
    transform: "matrix(-0.815253 -0.579293 0.559228 -0.82913 27.2832 111.768)",
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.77527,
    height: 3.81386,
    transform: "matrix(-0.595037 -0.807973 0.808066 -0.58315 25.4551 113.783)",
    fill: "url(#pattern1)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7355 144.973L153.371 44.668L83.8096 11.8154L19.921 106.563L85.7355 144.973Z",
    fill: "url(#paint6_linear_702_70636)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3592 124.161C64.7955 123.518 65.6945 123.379 66.3658 123.853C67.0377 124.327 67.2274 125.234 66.791 125.877C66.3538 126.521 65.4548 126.66 64.7829 126.186C64.1116 125.712 63.9219 124.805 64.3592 124.161Z",
    fill: "#363535"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1079 111.31C42.5447 110.666 43.4426 110.528 44.1145 111.002C44.7864 111.476 44.9759 112.381 44.5391 113.025C44.1019 113.669 43.2044 113.807 42.5325 113.333C41.8606 112.859 41.6707 111.954 42.1079 111.31Z",
    fill: "#363535"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7118 124.323C65.9327 124.48 66.0306 124.769 65.9338 125.023C65.8891 125.138 61.4484 136.612 57.0019 144.242C51.3469 153.943 43.5441 157.104 35.5947 152.914C31.9972 151.018 29.6801 148.505 28.7073 145.447C26.8948 139.761 29.6259 133.018 34.2821 124.642C40.1897 114.016 43.017 111.637 43.1349 111.542C43.3745 111.345 43.7377 111.391 43.9435 111.643C44.1517 111.895 44.1252 112.258 43.8837 112.454C43.8586 112.475 41.0549 114.876 35.2903 125.244C31.3831 132.272 28.0141 139.546 29.797 145.145C30.6829 147.921 32.7382 150.129 36.087 151.895C46.5084 157.388 53.4877 147.938 56.0042 143.62C60.4077 136.063 64.8165 124.672 64.8603 124.558C64.9742 124.265 65.3061 124.133 65.6008 124.261L65.7118 124.323",
    fill: "url(#paint7_linear_702_70636)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_702_70636",
    transform: "scale(0.0454545 0.1)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_702_70636",
    transform: "scale(0.0454545 0.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_702_70636",
    x1: -78.4305,
    y1: 157.338,
    x2: 223.476,
    y2: 26.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.478495,
    stopColor: "#A6A5A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242222"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_702_70636",
    x1: 79.1369,
    y1: 123.796,
    x2: 27.6784,
    y2: 169.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_702_70636",
    x1: 57.9036,
    y1: 134.551,
    x2: 61.4356,
    y2: 128.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F8082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_702_70636",
    x1: 6.5979,
    y1: 136.842,
    x2: 150.712,
    y2: 87.7464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCCC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_702_70636",
    x1: 113.413,
    y1: 69.0166,
    x2: 199.684,
    y2: 42.9868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCCC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_702_70636",
    x1: 85.6488,
    y1: 166.15,
    x2: 166.942,
    y2: 58.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDCCC9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_702_70636",
    x1: 14.1358,
    y1: 115.67,
    x2: 324.836,
    y2: -56.6832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FBCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_702_70636",
    x1: 64.7498,
    y1: 116.483,
    x2: 21.7782,
    y2: 153.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAEBE9"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_702_70636",
    width: 22,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAKCAYAAACwoK7bAAAABHNCSVQICAgIfAhkiAAAAMxJREFUKJGFkluSwyAMBHsGBNm7J1cO+8FjYxtnVUXJNqglD6Pn69VKBFEKP49KrZWIoJZCjkzJQY5M5CDlRCkFO+Fk0siSEcewJCRhGyQ83ucCLnk+y0Iyu1jgpMPHQ/EnbEZrbQtcDEs4eQHvJp0NPvfbu9Haew8GEAKPgg3c8shXKW4nZhy2fZDAFuKq91mSJc1YCzynBJDHJfbqJc0Cen9R5wYdvKb9K/rmiOmCKc8d3GtT3Tq7Czs3u5h2E+4G747w7vdvHPFf/AKjdhHA5NNilgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_702_70636",
    width: 22,
    height: 10,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAKCAYAAACwoK7bAAAABHNCSVQICAgIfAhkiAAAAUpJREFUKJFtkkuiGyEMBEsf7LxTJ7n2gFpZgMfPSdgiiuoG+/nrd399/WCMwchkPB48n4PneDDGIDIZmUQEkcGIxMNxd8yM8MDMeK3uBiDVzaoiImhAKrScaetjeHTT3bSEa8PCnOULM7vhN7iqqFVUFGttmJtv4hnOA02JKse9yAzqzHw3BmiJbIlVhc91x5tnQFxUOEMiM1AF5ruGtfzD1Mx2opfEXOu+1fy9CaAWVUGXWBW4B+FOhGPmhH8m45xVN7m+mQIY71jqxq3okdgqIgN3u03d/A09YLW28arCrnlbAkiJJCICd0fSib/wOBVgn9ADBmianNd1Q1+vLom5nJGJuZHngleybWv/sT0VSuSc172RSlQiJcIdlTA3phkR+4v56dX9L1tAapqm1eQ1F91QVdQBVtU2jLnrMMOO7e71H+Zt2t3QzR/GceQeVJABNgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo182);
export default __webpack_public_path__ + "static/media/logo182.ff44454799c80c37c52107f76ffcd335.svg";
export { ForwardRef as ReactComponent };